<p-dialog
	width="600"
	header="Importar datos PAC"
	[closeOnEscape]="false"
	[closable]="false"
	[visible]="visible"
	(onShow)="scrollToTop()"
>
	@if (visible) {
		<div class="finca-pac-dialog-content">
			<p-fileUpload
				name="myfile[]"
				[disabled]="!enableUpload || !urlUpload"
				[multiple]="false"
				[showCancelButton]="false"
				chooseLabel="Seleccionar archivo"
				uploadLabel="Enviar"
				[url]="urlUpload"
				(onSelect)="checkFile($event)"
				(onUpload)="uploaded($event)"
			></p-fileUpload>

			@if (showPACError) {
				<br />
				<p class="finca-pac-message finca-pac-message--error" [innerHTML]="txtPACError"></p>
				<p class="finca-pac-message finca-pac-message--info" [innerHTML]="txtPACInfo"></p>
			}

			<br />
			<div class="d-flex justify-content-center">
				<button class="btn btn-dark mx-2" (click)="close()" type="button">Cerrar</button>
			</div>
			<br />
		</div>
	}
</p-dialog>
